import "tw-elements";
import { Auth } from "aws-amplify";
import { useContext } from "react";
import UserContext from "../../contexts/UserContext";
import SignOut from "./signout";
import { extractPermission } from "../../helpers/extract";
import { FcDataConfiguration } from "react-icons/fc";
import ProfileIcon from "../../components/ProfileIcon";
import { /*AiTwotoneThunderbolt,*/ AiOutlineControl } from "react-icons/ai";
import { CgSoftwareDownload } from "react-icons/cg";
import { useLocation } from "react-router-dom";
import { BiImport } from "react-icons/bi";
import { FaRegUserCircle } from "react-icons/fa";
import { TbLayersSubtract } from "react-icons/tb";









function Header() {
  const location = useLocation();
  const { user } = useContext(UserContext);
  const permission = extractPermission(user);
  const userRole: string = permission.role ? permission.role : "none";

  const signOut = () => {
    Auth.signOut()
      .then(() => {
        window.location.href = "/"; //redirect back to homepage.
      })
      .catch((err) => {
        console.log(err);
      });
    window.localStorage.clear();
  };

  return (
    <>
      <SignOut signOut={signOut} />
      <header>
        <nav
          className="relative flex items-center justify-between w-full py-2 bg-white shadow-lg text-neutral-600 hover:text-neutral-700 focus:text-neutral-700 dark:bg-neutral-600 dark:text-neutral-200 md:flex-wrap md:justify-start"
          data-te-navbar-ref
        >
          <div className="flex flex-wrap items-center justify-between w-full px-6">

            <div>  
              <div className="flex items-center">
                <button
                  className="py-2 mr-2 text-xl leading-none transition-shadow duration-150 ease-in-out bg-transparent border-0 hover:text-neutral-700 focus:text-neutral-700 dark:hover:text-white dark:focus:text-white lg:hidden"
                  type="button"
                  data-te-collapse-init
                  data-te-target="#navbarSupportedContentY"
                  aria-controls="navbarSupportedContentY"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="[&>svg]:w-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                      />
                    </svg>
                  </span>
                </button>
              </div>
              <div
                className="!visible hidden grow basis-[100%] items-center lg:!flex lg:basis-auto"
                id="navbarSupportedContentY"
                data-te-collapse-item
              >
                <ul
                  className="flex flex-col mr-auto lg:flex-row"
                  data-te-navbar-nav-ref
                >
                  <li data-te-nav-item-ref>
                    <a
                      className="block transition duration-150 ease-in-out hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 dark:hover:text-white dark:focus:text-white lg:p-2 [&.active]:text-black/90"
                      href="/"
                      data-te-nav-link-ref
                      data-te-ripple-init
                      data-te-ripple-color="light"
                    >
                      <span className="font-bold">Product</span>{" "}
                      <span className="font-bold text-blue-700">Library</span>
                    </a>
                  </li>
                  <li data-te-nav-item-ref>
                    <a
                      href="/search"
                      className={
                        location.pathname.includes("search")
                          ? "block transition duration-150 ease-in-out hover:text-blue-700 focus:text-blue-700 disabled:text-blue/30 dark:hover:text-white dark:focus:text-white lg:p-2 [&.active]:text-blue/90 text-blue-500"
                          : "block transition duration-150 ease-in-out hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 dark:hover:text-white dark:focus:text-white lg:p-2 [&.active]:text-black/90"
                      }
                      data-te-nav-link-ref
                      data-te-ripple-init
                      data-te-ripple-color="light"
                    >
                      <span className="text-sm font-bold">Search</span>
                    </a>
                  </li>
                  <li data-te-nav-item-ref>
                    <a
                      href="/product-knowledge"
                      className={
                        location.pathname.includes("product-knowledge")
                          ? "block transition duration-150 ease-in-out hover:text-blue-700 focus:text-blue-700 disabled:text-blue/30 dark:hover:text-white dark:focus:text-white lg:p-2 [&.active]:text-blue/90 text-blue-500"
                          : "block transition duration-150 ease-in-out hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 dark:hover:text-white dark:focus:text-white lg:p-2 [&.active]:text-black/90"
                      }
                      data-te-nav-link-ref
                      data-te-ripple-init
                      data-te-ripple-color="light"
                    >
                      <span className="text-sm font-bold">Product Knowledge</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex gap-1">
              <div className="relative gap-1 px-2 py-1 text-center rounded-md xs:flex sm:flex-row sm:justify-center md:mr-3 " >
                <div className="flex items-center gap-1">  
                  {/* <span ><AiTwotoneThunderbolt size={20} color="yellow"/></span> */}
                  <span className="text-sm font-semibold">Powered by</span>{" "}
                  <a className="text-whitehite" href="/">
                    <span className="font-bold text-transparent uppercase bg-gradient-to-r from-danger to-primary bg-clip-text">Neo-IT</span>
                  </a>
                </div>
              </div>

              <div className="relative" data-te-dropdown-ref>
                {permission.role === "admin" && (
                  <>
                    <a
                      className="hidden-arrow mr-4 flex items-center text-neutral-500 hover:text-neutral-700 focus:text-neutral-700 disabled:text-black/30 dark:text-neutral-200 dark:hover:text-neutral-300 dark:focus:text-neutral-300 [&.active]:text-black/90 dark:[&.active]:text-neutral-400"
                      href="importArea"
                      id="dropdownMenuButton1"
                      role="button"
                      data-te-dropdown-toggle-ref
                      aria-expanded="false"
                    >
                      <FcDataConfiguration size={25} />
                    </a>
                    <ul
                      className="absolute left-auto right-0 z-[1000] float-left m-0 mt-1 hidden min-w-max list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left text-base shadow-lg dark:bg-neutral-700 [&[data-te-dropdown-show]]:block"
                      aria-labelledby="dropdownMenuButton1"
                      data-te-dropdown-menu-ref
                    >
                      <li>
                        <a
                          className="block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-transparent whitespace-nowrap hover:bg-blue-100 active:text-blue-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-blue-400 dark:text-blue-200 dark:hover:bg-white/30"
                          href="/importArea"
                          data-te-dropdown-item-ref
                        >
                          <div className="flex items-center gap-2">
                            <BiImport size={20} />
                            <span className="">Import Area</span>
                          </div>
                        </a>
                      </li>

                      <li>
                        <a
                          className="block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-transparent whitespace-nowrap hover:bg-blue-100 active:text-blue-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-blue-400 dark:text-blue-200 dark:hover:bg-white/30"
                          href="/userPermissions"
                          data-te-dropdown-item-ref
                        >
                          <div className="flex items-center gap-2">
                            <FaRegUserCircle size={20} />
                            <span className="">User Permissions</span>
                          </div>
                        </a>
                      </li>

                      {/* <li>
                        <a
                          className="block w-full px-4 py-2 text-sm font-normal bg-transparent whitespace-nowrap text-rose-700 hover:bg-rose-100 active:text-rose-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-rose-400 dark:text-rose-200 dark:hover:bg-white/30"
                          href="master"
                          data-te-dropdown-item-ref
                        >
                          <div className="flex items-center gap-2">
                            <AiOutlineFileSync size={20} />
                            <span className="">Sync Master Data</span>
                          </div>
                        </a>
                      </li> */}

                      <li>
                        <a
                          className="block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-transparent whitespace-nowrap hover:bg-blue-100 active:text-blue-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-blue-400 dark:text-blue-200 dark:hover:bg-white/30"
                          href="/controlPanel"
                          data-te-dropdown-item-ref
                        >
                          <div className="flex items-center gap-2">
                            <AiOutlineControl size={20} />
                            <span className="">Control Panel</span>
                          </div>
                        </a>
                      </li>

                      <li>
                        <a
                          className="block w-full px-4 py-2 text-sm font-normal text-gray-700 bg-transparent whitespace-nowrap hover:bg-blue-100 active:text-blue-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-blue-400 dark:text-blue-200 dark:hover:bg-white/30"
                          href="/banners"
                          data-te-dropdown-item-ref
                        >
                          <div className="flex items-center gap-2">
                            <TbLayersSubtract size={20} />
                            <span className="">Manage Banner</span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </>
                )}
              </div>

              <div className="relative" data-te-dropdown-ref>
                <a
                  className="flex items-center transition duration-150 ease-in-out hidden-arrow whitespace-nowrap motion-reduce:transition-none"
                  href="profile"
                  id="dropdownMenuButton2"
                  role="button"
                  data-te-dropdown-toggle-ref
                  aria-expanded="false"
                >
                  <ProfileIcon permission={userRole} />
                </a>

                <ul
                  className="absolute left-auto right-0 z-[1000] float-left m-0 mt-1 hidden min-w-max list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left text-base shadow-lg dark:bg-neutral-700 [&[data-te-dropdown-show]]:block"
                  aria-labelledby="dropdownMenuButton2"
                  data-te-dropdown-menu-ref
                >
                  <li>
                    <a
                      className="block w-full px-4 py-2 text-sm font-normal bg-transparent whitespace-nowrap text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-neutral-400 dark:text-neutral-200 dark:hover:bg-white/30"
                      href="/profile"
                      data-te-dropdown-item-ref
                    >
                      User Profile
                    </a>
                  </li>

                  {/* <li>
                    <a
                      className="block w-full px-4 py-2 text-sm font-normal bg-transparent whitespace-nowrap text-neutral-700 hover:bg-neutral-100 active:text-neutral-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-neutral-400 dark:text-neutral-200 dark:hover:bg-white/30"
                      href="profile"
                      data-te-dropdown-item-ref
                    >
                      Configurations
                    </a>
                  </li> */}

                  <li>
                    <a
                      className="block w-full px-4 py-2 text-sm font-normal text-red-700 bg-transparent whitespace-nowrap hover:bg-red-100 active:text-neutral-800 active:no-underline disabled:pointer-events-none disabled:bg-transparent disabled:text-neutral-400 dark:text-neutral-200 dark:hover:bg-white/30"
                      href="/profile"
                      data-te-toggle="modal"
                      data-te-target="#signoutModal"
                      data-te-ripple-init
                      data-te-ripple-color="light"
                      data-te-dropdown-item-ref
                    >
                      Sign Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;
